package com.downdogapp.client.singleton

object FileSystem : FileSystemHelperInterface by FileSystemHelper

expect object FileSystemHelper : FileSystemHelperInterface

interface FileSystemHelperInterface {

  fun createDirectory(path: String)

  fun listDirectoryContents(path: String): List<String>

  fun removeFile(path: String)

  fun getFileSize(path: String): Long

  fun downloadToFile(url: String, destinationPath: String, onComplete: (String, Error?) -> Unit): Long

  fun getDownloadTask(downloadId: Long): DownloadTask?

  fun cancelDownload(downloadId: Long)
}

expect class DownloadTask {

  val url: String
  val destinationPath: String
  val onComplete: (String, Error?) -> Unit

  fun getProgressProportion(): Double
}
